export const getProvinceUrl = () => "portal-person-info/profile/province";

export const getDistrictUrl = (provinceCode: string) =>
  `portal-person-info/profile/${provinceCode}/district`;

export const getWardUrl = (districtCode: string) =>
  `portal-person-info/profile/${districtCode}/ward`;
